/**
 * Áudio de inspiração (A134): o áudio que a marca sobe para ajudar a
 * paciente a começar a escrever — a sugestão da escritora na reunião de
 * sprint de 09/10/2026 ("para ela não ficar com um espaço em branco").
 *
 * Um por marca, ferramenta e jornada. O geral mantém o id legado
 * `<brandId>__<toolKey>`; o específico usa `<brandId>__<toolKey>__<journey>`.
 * A paciente ouve o da sua jornada, senão o geral da marca; sem os dois,
 * procura os mesmos alvos na Eva antes da frase escrita do app.
 */
import { z } from 'zod';
import { brandIdField } from './brand';
import { CareJourneyEnum } from './care-item.schema';

/** As ferramentas que aceitam áudio de inspiração. A Carta usa o do diário: ela mora nele. */
export const FERRAMENTAS_COM_INSPIRACAO = ['diario'] as const;

export const TIPOS_DE_AUDIO_ACEITOS = ['audio/mpeg', 'audio/mp3', 'audio/mp4', 'audio/x-m4a', 'audio/aac', 'audio/wav', 'audio/x-wav', 'audio/ogg', 'audio/webm'];
export const TAMANHO_MAXIMO_DO_AUDIO = 30 * 1024 * 1024;

export const AudioDeInspiracaoSchema = z.object({
  id: z.string(),
  brandId: brandIdField(),
  toolKey: z.string(),
  /** Ausente nos documentos antigos, ou nulo: áudio geral da ferramenta. */
  journey: CareJourneyEnum.nullable().optional(),
  url: z.string().url(),
  /** O nome do arquivo enviado, para a equipe reconhecer o que subiu. */
  nome: z.string().max(200),
  enviadoPor: z.string().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type AudioDeInspiracao = z.infer<typeof AudioDeInspiracaoSchema>;
